import { Mark, mergeAttributes } from '@tiptap/core';
const HighlightCssClass = 'ov-highlight';
export const Highlight = Mark.create({
    name: 'highlight',
    addOptions() {
        return {
            styles: undefined,
        };
    },
    parseHTML() {
        return [{ tag: `span.${HighlightCssClass}` }];
    },
    renderHTML({ HTMLAttributes }) {
        const styleAttr = this.options.styles
            ? {
                style: Object.entries(this.options.styles)
                    .map(([k, v]) => `${k}: ${v}`)
                    .join('; '),
            }
            : {};
        return [
            'span',
            mergeAttributes({ class: HighlightCssClass }, styleAttr, HTMLAttributes),
            0,
        ];
    },
});
export { HighlightCssClass };
